import axiosInstance from "./axios";

// Fetches the first page of the current user's media library.
// `mediaType` ("image" | "video") uses the backend's existing server-side
// filter so cursor pagination stays correct as the filter changes.
export const fetchMediaAssets = async (token, { mediaType, signal } = {}) => {
  try {
    const { data } = await axiosInstance.get(`/media/`, {
      headers: { Authorization: `Token ${token}` },
      params: mediaType && mediaType !== "all" ? { media_type: mediaType } : {},
      signal,
    });
    return data; // { next, previous, results }
  } catch (err) {
    console.error("Error fetching media assets", err);
    throw err;
  }
};

// Follows the backend's cursor `next` link as-is (it already carries any
// active filter params), matching the existing nextUrl pagination pattern.
export const fetchMediaAssetsPage = async (nextUrl, token) => {
  try {
    const { data } = await axiosInstance.get(nextUrl, {
      headers: { Authorization: `Token ${token}` },
    });
    return data;
  } catch (err) {
    console.error("Error fetching media assets page", err);
    throw err;
  }
};
